import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { DEFAULT_ROUTES_BY_ROLE } from '@auth/consts/default-routes-by-role.const';
import { Role } from '@auth/enums/role.enum';
import { RbsService } from '@auth/services/rbs.service';
import { Url } from '@core/enums/url.enum';

export const hasRoleGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const rbsService = inject(RbsService);
  const requiredRoles = route.data['roles'] as Role[];

  const selectedUserOrganization = rbsService.selectedUserOrganization();

  if (!selectedUserOrganization) {
    return router.createUrlTree([Url.AuthLanding]);
  }

  if (!Array.isArray(requiredRoles) || !requiredRoles.length) {
    return false;
  }

  const userRole = selectedUserOrganization.role;

  if (!Object.values(Role).includes(userRole)) {
    return false;
  }

  return (
    requiredRoles.includes(userRole) || router.createUrlTree([DEFAULT_ROUTES_BY_ROLE[userRole]])
  );
};
